import { Stack } from '@fluentui/react';
import 'intro.js/introjs.css';
import { DividerBox } from 'rc-dock';
import 'rc-dock/dist/rc-dock.css';
import React from 'react';
import 'styles/resize-handle.css';
import CommonRoomList from './CommonRoomList';
import PersonalRoomList from './PersonalRoomList';
import RoomListPanels from './RoomListPanels';
export interface IindexViewProps {
    personalRoomIds: string[];
    isPersonalRoomsLoading: boolean;
}

const IndexView: React.FC<IindexViewProps> = (props) => {
    const showPersonalSection = props.personalRoomIds.length > 0 || props.isPersonalRoomsLoading;

    return (
        <Stack style={{ maxHeight: '100%', height: '100%' }}>
            <RoomListPanels />

            <Stack style={{ maxHeight: '100%', height: '100%' }}>
                <DividerBox mode="vertical" style={{ height: '100%' }}>
                    {showPersonalSection && <PersonalRoomList />}

                    <div style={{ height: showPersonalSection ? '50%' : '100%', display: 'flex', flexDirection: 'column' }}>
                        <CommonRoomList />
                    </div>
                </DividerBox>
            </Stack>
        </Stack>
    );
};

export default IndexView;
